import { ISingleLuidParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class DeleteMetricRequest extends Request<{ metricLuid: string }, IResult> {
  constructor(metricLuid: string) {
    super('deleteMetric', { metricLuid });
  }
}
